<template>
  <v-row >
    <v-col v-if="!props.jobId" sm="12" class="pb-0 mb-0">
      <v-card flat>
        <v-card-title class="py-0">

          <v-chip-group
            v-model="selectedJobStatusIndexes"
            mandatory
            multiple
            selected-class="bg-blue-darken-1"
            class="align-center"
          >
            <h4 class="workOrderFilterLabel">
              {{ t('filterByProjectStatus') }}:
            </h4>
            <v-chip v-for="filterOption in filterJobStatuses"
              :key="filterOption"
              flat
            >
              {{ t(`jobStatuses.${filterOption}` , '') }}
            </v-chip>
          </v-chip-group>
          <!-- Right aligned things -->
        </v-card-title>
      </v-card>
    </v-col>

    <v-col sm="12" class="pb-0 mb-0">
      <v-card flat>
        <v-card-title class="py-0">

          <v-chip-group
            v-model="selectedStatusIndexes"
            mandatory
            multiple
            selected-class="bg-blue-darken-1"
            class="align-center"
          >
            <v-chip v-for="filterOption in filterStatuses"
              :key="filterOption"
              flat
            >
              {{ t(`workOrderStatuses.${filterOption}` , '') }}
            </v-chip>
          </v-chip-group>
          <!-- Right aligned things -->
        </v-card-title>
      </v-card>
    </v-col>

    <v-col sm="12" class="pb-0 pt-0">
      <v-card flat>
        <v-card-title class="pl-0">
          <v-table class="ma-0">
            <th style="width: 43px; vertical-align: middle;" class="pt-3">
                {{ t('search') }}
              </th>
              <th v-for="header in searchHeaders" :key="header.key"  class="py-0" :style="{width: `${header.width}px !important`}" >
                <v-text-field
                  v-if="header.search && header.search !== 'category'"
                  v-model="searchValue[(header.search as string)]"
                  :placeholder="header.title"
                  append-inner-icon="mdi-magnify"
                  clearable
                  @click.stop
                  @keydown.space.stop
                  variant="underlined"
                  class="px-2"
                  hide-details
                  @update:modelValue="val => debouncedSearch(header.search as string, val)"
                />
                <v-select
                  v-else-if="header.search === 'category'"
                  v-model="searchValue[(header.search as string)]"
                  :items="categoryItems"
                  variant="underlined"
                  :placeholder="$t('category')"
                  clearable
                  hide-details
                  @update:modelValue="val => debouncedSearch(header.search as string, val)"
                ></v-select>
                <span v-else>{{ header.title }}</span>
              </th>
          </v-table>
        </v-card-title>
      </v-card>
    </v-col>

    <v-col sm="12" class="pt-0" >
      <v-card flat border>
        <v-card-text class="px-0 pt-0">
          <v-data-table-server
            :headers="headers"
            :items="workOrdersList"
            :loading="workOrdersListLoading"
            :items-per-page-text="rowsPerPageText"
            :items-per-page-options="rowsPerPageItems"
            v-model:items-per-page="pagination.rowsPerPage"
            v-model:page="pagination.page"
            :items-length="workOrdersListTotalCount"
            sort-asc-icon="mdi-sort-ascending"
            sort-desc-icon="mdi-sort-descending"
            @update:sort-by="sortEvent"
          >
            <template v-slot:headers="{isSorted, getSortIcon, toggleSort }">
              <tr>
                <template v-for="header in headers" :key="header.key" >
                  <th class="custom_header_table custom-bg" :style="{width: `${header.width}px !important`}" >
                    <span class="d-flex align-center" @click="header.sortable ? toggleSort(header) : ''">
                      <span :class="header.sortable ? 'pointer' : ''" class="font-weight-bold">{{ capitalcase(header.title) }}</span>
                      <template v-if="isSorted(header)">
                        <v-icon :icon="getSortIcon(header)" size="small" style="margin: 5px"></v-icon>
                      </template>
                      <template v-if="header.sortable && !isSorted(header)">
                        <v-icon icon="mdi-sort" size="small" style="margin: 5px"></v-icon>
                      </template>
                    </span>

                    <!-- <v-text-field
                      v-if="header.search"
                      v-model="search[(header.search as string)]"
                      placeholder="Zoek"
                      clearable
                      @click.stop
                      @keydown.space.stop
                      variant="underlined"
                    /> -->
                  </th>
                </template>
              </tr>
            </template>

            <template v-slot:item="{ item }: {item: any}">
              <tr>
                <td>
                  <v-menu
                    location="end center"
                    :offset="10"
                    open-on-hover
                  >
                    <template v-slot:activator="{ props, isActive }">
                      <v-btn
                        v-bind="props"
                        icon
                        size="small"
                      >
                        <v-icon :class="{'reset-icon': !isActive , 'convert-icon': isActive}">{{!isActive ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
                      </v-btn>
                    </template>

                    <v-row class="bg-grey-lighten-2 rounded-xl">
                      <DuplicateWorkOrderButton :work-order="item" button-type="icon" @duplicated="refreshList" />
                      <v-tooltip
                        v-if="auth.check('edit work orders')"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            @click.stop="item.is_in_pro_formas ? false : router.push({ name: 'WorkOrdersEdit', params: { id: item.id }})"
                            icon
                            size="small"
                            color="grey"
                            class="mr-1 second show-icon"
                            :class="{
                              'disabled': item.is_in_pro_formas
                            }"
                          >
                            <v-icon>
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ item.is_in_pro_formas  ? $t('workOrderInProFormaPeriod') : $t('edit') }}</span>
                      </v-tooltip>
                      <v-tooltip
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            @click.stop="printWorkOrder(item.id)"
                            icon
                            size="small"
                            color="blue"
                            class="fourth show-icon"
                          >
                            <v-icon>
                              mdi-printer
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('print') }}</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="auth.check('delete work orders')"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            @click.stop="printWorkOrder(item.id)"
                            icon
                            size="small"
                            color="blue"
                            class="fourth show-icon"
                          >
                            <v-icon>
                              mdi-printer
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('print') }}</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="auth.check('delete work orders')"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            @click.stop="deleteWorkOrder(item.id)"
                            icon
                            size="small"
                            color="red"
                            class="third show-icon"
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('delete') }}</span>
                      </v-tooltip>
                    </v-row>
                  </v-menu>
                </td>
                <td v-if="props.jobId == 0" class="ws-nowrap">
                  <router-link class="custom-a" v-if="item.job" :to="{ name: 'JobsView', params: { id: item.job.id }}">
                    {{ item.job ? item.job.job_name : '' }}
                  </router-link>
                </td>
                <td class="ws-nowrap">
                  <v-tooltip
                    location="top"
                    :text="item.standard_name_prefix"
                    open-delay="300"
                  >
                    <template v-slot:activator="{ props }">
                      <router-link class="custom-a" v-bind="props" :to="{ name: 'WorkOrdersView', params: { id: item.id }}">
                        {{ item.standard_name_prefix }}
                      </router-link>
                    </template>
                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip
                    location="top"
                    :text="item.instructions"
                    :max-width="headerWidth('instructions')"
                    open-delay="300"
                  >
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" class="ws-nowrap ws-ellipsis d-inline-block" v-if="item.instructions" :style="{width: `${headerWidth('instructions')}px !important`}">
                        <span>{{ item.instructions }}</span>
                      </span>
                    </template>

                  </v-tooltip>
                </td>
                <td>
                  <v-tooltip
                    v-if="item.client"
                    location="top"
                    :text="item.client ? clientNameAndAddress(item) : ''"
                    :max-width="headerWidth('clients.name')"
                    open-delay="300"
                  >
                    <template v-slot:activator="{ props }">
                      <router-link class="custom-a ws-ellipsis d-inline-block" v-bind="props" :to="{ name: 'ClientsEdit', params: { id: item.client.id }}" :style="{width: `${headerWidth('clients.name')}px !important`}">
                        <span class="ws-nowrap ws-ellipsis">{{ item.client ? item.client.name : '' }}</span>
                        <template v-if="item.project_name && item.project_name.trim()">
                          <br>
                          <span class="ws-nowrap"><small>{{ item.project_name.trim() }}</small></span>
                        </template>
                      </router-link>
                    </template>
                  </v-tooltip>
                </td>
                <td>
                  <div v-if="item.client_responsible_1" class="ws-nowrap">
                    <template v-if="item.client_responsible_1.phone">
                      <v-tooltip bottom v-slot:activator>
                        <span >{{ item.client_responsible_1.name }} </span>
                        <div><v-icon size="small" class="mr-1">mdi-phone</v-icon>{{ item.client_responsible_1.phone }}</div>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      {{ item.client_responsible_1.name }}
                    </template>
                  </div>
                  <div v-if="item.client_responsible_2" class="ws-nowrap">
                    <template v-if="item.client_responsible_2.phone">
                      <v-tooltip bottom v-slot:activator>
                        <span >{{ item.client_responsible_2.name }} </span>
                        <div><v-icon size="small" class="mr-1">mdi-phone</v-icon>{{ item.client_responsible_2.phone }}</div>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      {{ item.client_responsible_2.name }}
                    </template>
                  </div>
                </td>
                <td>
                  <CategoryBadge :category="item.workOrderCategory" />
                </td>
                <td>
                  <template v-for="name in employeeNames(item.employees)" class="employee" :key="name">
                    <span class="ws-nowrap" >{{ name }}</span><br>
                  </template>
                </td>
                <td>
                  <span class="date ws-nowrap ml-0 d-inline-flex align-center">
                    <template v-if="item.datetime_start">
                      <span>{{ prettyDateFormat(item.datetime_start) }}</span>
                    </template>
                    <v-tooltip v-if="item.datetime_start_locked" :text="t('datetimeStartLocked')" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" size="x-small" color="grey" class="ml-1">mdi-lock</v-icon>
                      </template>
                    </v-tooltip>
                  </span>
                </td>
                <td>
                  <v-tooltip
                    location="top"
                    :text="item.location ? item.location.location : ''"
                    :max-width="headerWidth('location')"
                    open-delay="300"
                  >
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" class="ws-nowrap ws-ellipsis d-inline-block" v-if="item.location" :style="{width: `${headerWidth('location')}px !important`}">
                        <span>{{ item.location ? item.location.location : '' }}</span>
                      </span>
                    </template>
                  </v-tooltip>
                </td>
                <td>
                  {{ item.responsible ? item.responsible.name : '' }}
                </td>
                <td>
                  {{ t(`workOrderStatuses.${item.status.name}`) }}<!--
                  NO WHITESPACE
                  --><span v-if="item.status === 'ONGOING' && item.status_ongoing">/ {{ t('workOrderStatusesOngoing.' + item.status_ongoing.name ) }}</span>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { debounce } from 'lodash-es'
import Say from '@/utils/Say'
import DuplicateWorkOrderButton from './DuplicateWorkOrderButton.vue'
import CategoryBadge from '@/components/WorkOrders/CategoryBadge.vue'

import { datatableOptions } from '@/mixins/datatableOptions'
import { prettyDateFormat, capitalcase } from '@/utils/filters'
import { computed, defineComponent, ref } from 'vue'
import { onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import useBranchSelector from '@/composable/useBranchSelector'
import { computedAsync } from '@vueuse/core'
import sayErrorResponse from '@/mixins/sayErrorResponse'
import { getWorkOrderPrintVersionUrl } from '@/api/workOrders'
import { useAuth } from '@/utils/auth'

const props = defineProps({
  jobId: {
    type: [String, Number],
    required: false,
    default: 0
  },
})

const auth = useAuth()
const { branchSelected } = useBranchSelector()

const { rowsPerPageText, rowsPerPageItems, pagination } = datatableOptions(false)
const { t } = useI18n()
const store = useStore()
const router = useRouter()
const route = useRoute()
const alreadyRetrieved = ref(false)

const isSmAndDown = ref(false); // Initialize with a default value

// Update the isSmAndDown value based on screen size
const handleResize = () => {
  isSmAndDown.value = window.innerWidth <= 1537; // Adjust the breakpoint value as needed
};

window.addEventListener('resize', handleResize);
handleResize();

const headers: any = ref([
  { width: 30, key: '' },
  { width: isSmAndDown.value ? 50 : 80, title: t('job', 2), key: 'jobs.job_name', sortable: true, search: 'jobs_name' },
  { width: isSmAndDown.value ? 50 : 100, title: t('workOrder', 2), key: 'standard_name_prefix', sortable: true, search: 'standard_name_prefix' },
  { width: isSmAndDown.value ? 80 : 150, title: t('instructions'), key: 'instructions', sortable: false, search: 'instructions' },
  { width: isSmAndDown.value ? 80 : 150, title: t('client', 2), key: 'clients.name', sortable: true, search: 'clients_name' },
  { width: isSmAndDown.value ? 50 : 100, title: t('contact', 1), key: 'contact', sortable: false, search: 'contacts' },
  { width: isSmAndDown.value ? 50 : 150, title: t('category'), key: 'category', sortable: false, search: 'category' },
  { width: isSmAndDown.value ? 50 : 100, title: t('employee', 2), key: 'employee', sortable: false, search: 'employees' },
  { width: isSmAndDown.value ? 50 : 100, title: t('start'), key: 'datetime_start', sortable: true, search: false },
  { width: isSmAndDown.value ? 50 : 150, title: t('location', 1), key: 'location', sortable: false, search: 'location' },
  { width: isSmAndDown.value ? 50 : 100, title: t('responsible'), key: 'employees.name', sortable: true, search: 'responsible' },
  { width: isSmAndDown.value ? 50 : 90,  title: t('status'), key: 'status', sortable: false, search: false }
])
if (props.jobId) {
  headers.value.splice(1, 1)
}

const searchHeaders: any = ref([
  { width: isSmAndDown.value ? 50 : 80, title: t('job', 2), search: 'jobs_name' },
  { width: isSmAndDown.value ? 60 : 100, title: t('workOrder', 2), search: 'standard_name_prefix' },
  { width: isSmAndDown.value ? 60 : 150, title: t('instructions'), search: 'instruction' },
  { width: isSmAndDown.value ? 60 : 150, title: t('client', 2), search: 'clients_name' },
  { width: isSmAndDown.value ? 70 : 100, title: t('contact', 1), search: 'contacts' },
  { width: isSmAndDown.value ? 70 : 150, title: t('category'), search: 'category' },
  { width: isSmAndDown.value ? 70 : 100, title: t('employee', 2), search: 'employees' },
  { width: isSmAndDown.value ? 70 : 100, title: '', search: false },
  { width: isSmAndDown.value ? 60 : 150, title: t('location', 1), search: 'location' },
  { width: isSmAndDown.value ? 50 : 100, title: t('responsible'), search: 'responsible' },
  { width: isSmAndDown.value ? 30 : 90, title: '', search: false },
])
if (props.jobId) {
  searchHeaders.value.splice(0, 1)
}

const filterStatuses= ref([
  'PLANNED',
  'ONGOING',
  'COMPLETED',
  'CANCELLED',
  'UNBILLABLE',
  'APPROVED',
])

const filterJobStatuses = ref([
  'ACTIVE',
  'COMPLETED',
  'CANCELLED',
])

const categoryItems= ref([
  'Plaatsen verkeersmaatregelen',
  'Retour verkeersmaatregelen',
  'Verkeer regelen',
  'Opdraaien verkeersmaatregelen',
  'Afdraaien verkeersmaatregelen',
  'Wegdekreiniging',
  'Afhalen',
  'Monteur(s) + trekkend voertuig',
  'Diverse',
  'Materiaal ophalen bij verhuur leverancier',
  'Materiaal terugbrengen naar verhuur leverancier',
  'Materiaal ophalen bij vestiging',
  'Materiaal brengen naar vestiging',
])

const selectedStatusIndexes = ref([0, 1, 2, 3, 4, 5])

const selectedJobStatusIndexes = ref([0])

const clientNameAndAddress = (item: any) => {
  const clientName = item.client ? item.client.name : '';
  const clientAddress = item.project_name && item.project_name.trim() ? item.project_name.trim() : '';

  return clientName && clientAddress
    ? `${clientName}\n${clientAddress}`
    : clientName;
}

const workOrdersListLoading = computed(() => {
  return store.getters.workOrdersListLoading
})
const workOrdersListTotalCount = computed(() => {
  return store.getters.workOrdersListTotalCount
})

const selectedStatuses = computed(() => {
  return selectedStatusIndexes.value.map(
    index => filterStatuses.value[index]
  )
})

const selectedJobStatuses = computed(() => {
  return selectedJobStatusIndexes.value.map(
    index => filterJobStatuses.value[index]
  )
})

onBeforeMount(() => {
  // UI
  if ('WorkOrdersList' === route.name) {
    store.commit('app.setPageTitle', t('workOrder', 2))
    store.commit('app.setBreadcrumbs', [
      { text: t('workOrder', 2) }
    ])
  }
  // NB also in use by JobsView
})

// Immediately updated model
const searchValue = ref<Record<string, string>>(searchHeaders.value.reduce((acc: any, val: any) => {
  if (!val.search) {
    return acc
  }

  acc[val.search] = ''
  return acc
}, {}))

// Model updated on a debounce
const search = ref<Record<string, string>>({})
const debouncedSearch = debounce((searchField: string, val) => {
  search.value[searchField] = val
}, 100)

if(route.query) {
  for (const [key, value] of Object.entries(route.query)) {
    if (value && !Array.isArray(value)) {
      search.value[key] = value
    }
  }
  router.replace({ query: {} })
}

const refreshTrigger = ref(0)

const workOrdersList = computedAsync(async() => {
  // Referenced only so this recomputes when refreshList() is called (e.g. after duplicating a work order).
  refreshTrigger.value

  let payload : { [key: string]: any } = {
    ...pagination.value,
    showHistoric: true,
    status: selectedStatuses.value.join(','),
    jobId: props.jobId,
  }

  if (!props.jobId) {
    payload.jobStatus = selectedJobStatuses.value.join(',')
  }

  for (const [key, value] of Object.entries(search.value)) {
    if (value) {
      payload[`s-${key}`] = value
    }
  }

  return await store.dispatch('workOrders.fetch', payload)
}, undefined, { flush: 'pre' })

const refreshList = () => {
  refreshTrigger.value++
}

const deleteWorkOrder = (id: number) => {
  let confirmAction = confirm(t('workOrderDeleteConfirm'))
  if (confirmAction) {
    store.dispatch('workOrders.delete', id).then(() => {
      Say('success', t('workOrderDeleteSuccess'))
    }).catch((err) => {
      sayErrorResponse(err)
    })
  }
}
const printWorkOrder = async (id: number) => {
  try {
    const response = await getWorkOrderPrintVersionUrl(id)
    if (response.data.url) {
      window.open(response.data.url, '_blank')
    } else {
      sayErrorResponse(response)
    }
  } catch (err: any) {
    sayErrorResponse(err)
  }
}
const employeeNames = (employees: any) => {
  if (!employees || !Array.isArray(employees)) return
  return employees.map(({ name }) => name)
}
const sortEvent = (value: any) => {

  if(value.length === 0) {
    return
  }

  Object.assign(pagination.value, {
    sortBy: value[0].key,
    descending: value[0].order === 'desc' ? true : false,
  })

  // done by watch(pagination)
  // getWorkOrders()
}
const openInNewTab = (itemId: any) => {
  const url = router.resolve({ name: 'WorkOrdersEdit', params: { id: itemId } }).href;
  window.open(url, '_blank', 'noopener noreferrer');
}

const headerWidth = (key: string) => {
  const header = headers.value.find((header: any) => header.key === key)
  if (header) {
    alreadyRetrieved.value = true
    return header.width
  }
}
</script>

<style lang="scss" scoped>
.workOrderFilterLabel {
  padding-top: 10px;
  width: 170px;
}

* {
  table.table {
    td {
      line-height: 20px;
    }

    td,
    th {
      padding: 5px 10px !important;
      position: relative;

      &.date {
        min-width: 100px;
        padding: 0 10px !important;
      }
    }

    th {
      vertical-align: top;

      .icon:not(.input-group__icon-clearable) {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}

.speed-dial {
  .btn {
    width: 2.5rem;
    height: 2.5rem;
    margin: 0;

    + .btn {
      margin-left: .3rem;
    }
  }

  .speed-dial__list {
    z-index: 999;
    background: #e0e0e0;
    border-radius: 1rem;
    height: 2.5rem;
  }

  .icon {
    font-size: 1.3rem;
  }
}

.ws-nowrap {
  white-space: nowrap;
}

.employee:not(:last-child) {
  &:after {
    content: ', ';
  }
}

.show-icon {
  &.first {
    animation: showIcon .1s linear;
  }
  &.second {
    animation: showIcon .12s linear .05s;
  }

  &.third {
    animation: showIcon .15s linear .05s;
  }

  &.fourth {
    animation: showIcon .18s linear .05s;
  }
}

.convert-icon {
  animation: convertIcon .1s linear;
  // animation: name duration timing-function delay iteration-count direction fill-mode;
  &:hover {
    animation: convertIcon .1s linear;
  }
}

.reset-icon {
  animation: resetIcon .1s linear;
}

.custom_header_table {
  padding: 0 10px !important;
}

tbody td {
  padding: 0 10px !important;
}

@keyframes showIcon {
  0% {
    opacity: 0;
    left: -50px;
  }

  100% {
    opacity: 1;
    left: 0;
  }
}

@keyframes convertIcon {
  0% {
    transform: rotate(-45deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes resetIcon {
  0% {
    transform: rotate(45deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
</style>
